import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import '../css/PersonalInformationModal.css';
import { setPassword, getReferralCode } from '../utils/PersonalInformationUtils';

function LegacyPersonalInformationModal({ isOpen, onClose }) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  // Password management state
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPasswordSection, setShowPasswordSection] = useState(false);

  // Referral code state
  const [loadingReferralCode, setLoadingReferralCode] = useState(false);

  const handleGetReferralCode = async () => {
    setLoadingReferralCode(true);
    setError(null);
    try {
      const data = await getReferralCode();
      const code = data.promoCode || data.referralCode || '';
      alert(t('account.referralMessage', { code }));
    } catch (err) {
      setError(t('account.referralError'));
    } finally {
      setLoadingReferralCode(false);
    }
  };

  const handlePasswordSave = async () => {
    if (newPassword !== confirmPassword) {
      setError(t('account.passwordMismatch'));
      return;
    }
    if (newPassword.length < 8) {
      setError(t('account.passwordLength'));
      return;
    }

    // Additional password strength validation
    const hasUpperCase = /[A-Z]/.test(newPassword);
    const hasLowerCase = /[a-z]/.test(newPassword);
    const hasNumbers = /\d/.test(newPassword);

    if (!hasUpperCase || !hasLowerCase || !hasNumbers) {
      setError(t('account.passwordStrength'));
      return;
    }

    try {
      await setPassword(newPassword);
      setNewPassword('');
      setConfirmPassword('');
      setShowPasswordSection(false);
      setError(null);
      alert(t('account.passwordSaved'));
    } catch (err) {
      setError(t('errors.password'));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="personal-info-modal-overlay">
      <div className="personal-info-modal-content">
        <h2>{t('account.settings')}</h2>


        {error && <p className="error-message">{error}</p>}

        <div className="personal-info-input-group">
          <div className="password-section">
            <label className="personal-info-label">{t('account.passwordOptional')}</label>
            <p className="password-description">{t('account.passwordHelp')}</p>

            {!showPasswordSection ? (
              <button
                className="set-password-button"
                onClick={() => setShowPasswordSection(true)}
              >{t('account.setPassword')}</button>
            ) : (
              <div className="password-inputs">
                <input
                  type="password"
                  placeholder={t('account.newPassword')}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="password-input"
                />
                <input
                  type="password"
                  placeholder={t('account.confirmPassword')}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="password-input"
                />
                <div className="password-buttons">
                  <button
                    className="save-password-button"
                    onClick={handlePasswordSave}
                  >{t('account.savePassword')}</button>
                  <button
                    className="cancel-password-button"
                    onClick={() => {
                      setShowPasswordSection(false);
                      setNewPassword('');
                      setConfirmPassword('');
                      setError(null);
                    }}
                  >{t('common.cancel')}</button>
                </div>
              </div>
            )}
          </div>

          <div className="referral-section">
            <label className="personal-info-label">{t('account.referralCode')}</label>
            <button
              className="get-referral-button-small"
              onClick={handleGetReferralCode}
              disabled={loadingReferralCode}
            >
              {loadingReferralCode ? t('common.getting') : t('account.getCode')}
            </button>
          </div>
        </div>

        <div className="personal-info-modal-buttons">
          <button className="personal-info-close-button" onClick={onClose}>{t('common.close')}</button>
        </div>
      </div>
    </div>
  );
}

export default LegacyPersonalInformationModal;
